// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  type ShipmentFilter,
  getShipments,
} from '@/shipment/api/get-shipments';
import { QuarantinedFilterChipBase } from '@/shipment/components/quarantined-filter-chip-base';
import { shipmentsQueryKey } from '@/shipment/hooks/use-shipments';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export function QuarantinedFilterChip(props: {
  filter: ShipmentFilter;
  isActive: boolean;
  onClick: () => void;
}) {
  const { data } = useQuery({
    queryKey: [...shipmentsQueryKey, props.filter],
    queryFn: () => getShipments(props.filter),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
    refetchInterval: 30_000,
    throwOnError: true,
  });

  if (data === undefined) {
    return (
      <QuarantinedFilterChipBase
        isActive={props.isActive}
        countStatus="loading"
        onClick={props.onClick}
      />
    );
  }

  return (
    <QuarantinedFilterChipBase
      isActive={props.isActive}
      countStatus="loaded"
      quarantinedCount={data.quarantinedCount}
      onClick={props.onClick}
    />
  );
}
